export default __webpack_public_path__ + "static/media/AngelaLamb.1a8e65b8.png";